import { render } from "./PartOrder.vue?vue&type=template&id=2991f284&scoped=true&bindings={}"
import script from "./PartOrder.vue?vue&type=script&lang=ts"
export * from "./PartOrder.vue?vue&type=script&lang=ts"

import "./PartOrder.vue?vue&type=style&index=0&id=2991f284&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2991f284"

export default script